import { CONTACT_AUTO_ANSWER } from 'lib/common/constants/contactAttributes';

import getContactAttributes from '../getContactAttributes';

const STRING_TRUE = 'true';

export default function isContactAutoAnswer(contact: connect.Contact): boolean {
  const { [CONTACT_AUTO_ANSWER]: autoAnswerAttribute } = getContactAttributes({ contact }, CONTACT_AUTO_ANSWER);

  return autoAnswerAttribute?.toLowerCase() === STRING_TRUE;
}
